@if(editable) {
<app-dynamic-form
  [fields]="fieldsEdit"
  [type]="'horizontal'"
  [editable]="editable"
  [translation]="true"
  (action)="handleAction($event)"
  (changes)="detectFormState($event)"
  (formChanges)="formChange($event)"
></app-dynamic-form>
}@else {
<app-dynamic-form
  [fields]="fieldsView"
  [type]="'horizontal'"
  [editable]="editable"
  [translation]="true"
  (changes)="detectFormState($event)"
></app-dynamic-form>
}


<p-toast></p-toast>